import { SequenceInstance, TweenEngineGreenSockInstance } from '../types';

export class Sequence implements SequenceInstance {
  constructor(
    engine: TweenEngineGreenSockInstance,
    params: { [key: string]: any } = {},
  ) {
    this.timeline = engine.timeline({ ...params }, []);
    this.add = this.add.bind(this);
    this.get = this.get.bind(this);
    this.event = this.event.bind(this);
    this.play = this.play.bind(this);
    this.reverse = this.reverse.bind(this);
    this.pause = this.pause.bind(this);
    this.seek = this.seek.bind(this);
    this.clear = this.clear.bind(this);
  }
  timeline: GSAPTimeline;
  /**
   * Add another animation, transition or sequence to the sequence
   */
  add(
    tweens: GSAPTween | GSAPTimeline | (GSAPTween | GSAPTimeline)[],
    position: string | number = '+=0',
  ): SequenceInstance {
    this.timeline.add(tweens, position);
    return this;
  }

  /**
   * Get the real timeline attached to the sequence
   */
  get(): GSAPTimeline {
    return this.timeline;
  }

  /**
   * Add/remove Timeline event handler
   * From GSAP Docs (https://greensock.com/docs/v3/GSAP/Timeline/eventCallback()):
   * .eventCallback( type:String, callback:Function, params:Array ) : [Function | self]
   * Gets or sets an event callback like onComplete, onUpdate, onStart, onReverseComplete, or onRepeat
   * along with any parameters that should be passed to that callback.
   */
  event(
    type:
      | 'onComplete'
      | 'onUpdate'
      | 'onStart'
      | 'onReverseComplete'
      | 'onRepeat',
    handler: GSAPCallback | null,
    ...args: any[]
  ): SequenceInstance {
    this.timeline.eventCallback(type, handler, ...args);
    return this;
  }

  /**
   * Play the timeline
   */
  play(): SequenceInstance {
    this.timeline.play();
    return this;
  }

  /**
   * Play the timeline backwards
   */
  reverse(): SequenceInstance {
    this.timeline.reverse();
    return this;
  }

  /**
   * Pause the timeline
   */
  pause(): SequenceInstance {
    this.timeline.pause();
    return this;
  }

  /**
   * Seek the timeline
   */
  seek(progress: any): SequenceInstance {
    this.timeline.totalProgress(progress);
    return this;
  }

  /**
   * Get the real timeline attached to the sequence
   */
  clear(): SequenceInstance {
    this.timeline.clear();
    return this;
  }
}
